import ResourceTyped from 'Resources/ResourceTyped';

/** Only these two fields are read. */
type Explore = {
	id: string;
	title: string;
};

/** One Looker explore the account may query. Same route shape as `LookerLook.ts`. */
class LookerExplore extends ResourceTyped<Explore> {
	constructor() {
		super('looker/explores');
	}
}

const resource = new LookerExplore();

export default resource;
